"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketEventHandlers = void 0;
var interfaces_1 = require("../../interfaces");
function SocketEventHandlers(cacheControl, handlerManager, getSocketId, getSubscriptions, getAccessToken) {
    var _this = this;
    var runUpdates = function (updates) { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            if (updates && updates instanceof Array) {
                updates.forEach(function (update) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!(update.ids.length > 0)) return [3, 16];
                                _a = update.name;
                                switch (_a) {
                                    case 'group': return [3, 1];
                                    case 'template': return [3, 4];
                                    case 'widget': return [3, 7];
                                    case 'entry': return [3, 10];
                                    case 'media': return [3, 13];
                                }
                                return [3, 16];
                            case 1: return [4, cacheControl.group.removeMany(update.ids)];
                            case 2:
                                _b.sent();
                                return [4, handlerManager.group.getMany(update.ids)];
                            case 3:
                                _b.sent();
                                return [3, 16];
                            case 4: return [4, cacheControl.template.removeMany(update.ids)];
                            case 5:
                                _b.sent();
                                return [4, handlerManager.template.getMany(update.ids)];
                            case 6:
                                _b.sent();
                                return [3, 16];
                            case 7: return [4, cacheControl.widget.removeMany(update.ids)];
                            case 8:
                                _b.sent();
                                return [4, handlerManager.widget.getMany(update.ids)];
                            case 9:
                                _b.sent();
                                return [3, 16];
                            case 10: return [4, cacheControl.entry.removeMany(update.ids)];
                            case 11:
                                _b.sent();
                                return [4, handlerManager.entry.getManyLite(update.ids)];
                            case 12:
                                _b.sent();
                                return [3, 16];
                            case 13: return [4, cacheControl.media.removeMany(update.ids)];
                            case 14:
                                _b.sent();
                                return [4, handlerManager.media.getMany(update.ids)];
                            case 15:
                                _b.sent();
                                return [3, 16];
                            case 16: return [2];
                        }
                    });
                }); });
            }
            return [2];
        });
    }); };
    return [
        {
            name: interfaces_1.SocketEventName.LANGUAGE,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            return [4, cacheControl.language.remove(data.entry._id)];
                        case 1:
                            _a.sent();
                            if (!(data.type !== 'remove')) return [3, 3];
                            return [4, handlerManager.language.get(data.entry._id)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            getSubscriptions()[interfaces_1.SocketEventName.LANGUAGE].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.GROUP,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (!(data.source !== getSocketId())) return [3, 2];
                            return [4, cacheControl.group.remove(data.entry._id)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(data.type === 'update')) return [3, 6];
                            if (!(data.source !== getSocketId())) return [3, 4];
                            return [4, handlerManager.group.get(data.entry._id)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [4, runUpdates(data.message.updated)];
                        case 5:
                            _a.sent();
                            return [3, 11];
                        case 6:
                            if (!(data.type === 'add')) return [3, 9];
                            if (!(data.source !== getSocketId())) return [3, 8];
                            return [4, handlerManager.group.get(data.entry._id)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8: return [3, 11];
                        case 9:
                            if (!(data.type === 'remove')) return [3, 11];
                            return [4, runUpdates(data.message.updated)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            getSubscriptions()[interfaces_1.SocketEventName.GROUP].forEach(function (sub) {
                                sub
                                    .handler({
                                    data: data,
                                    updates: data.message.updated,
                                })
                                    .catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.TEMPLATE,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data, entriesToRemove, _a, _b, _i, i, entry;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            data = rawData;
                            if (data.source !== getSocketId()) {
                                cacheControl.template.remove(data.entry._id);
                            }
                            entriesToRemove = cacheControl.entry.find(function (e) { return e.data.templateId === data.entry._id; });
                            _a = [];
                            for (_b in entriesToRemove)
                                _a.push(_b);
                            _i = 0;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3, 4];
                            i = _a[_i];
                            entry = entriesToRemove[i];
                            return [4, cacheControl.entry.remove(entry._id)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3, 1];
                        case 4:
                            if (!(data.type === 'update')) return [3, 9];
                            if (!(data.source !== getSocketId())) return [3, 6];
                            return [4, handlerManager.template.get(data.entry._id)];
                        case 5:
                            _c.sent();
                            _c.label = 6;
                        case 6: return [4, handlerManager.entry.getAllLite(data.entry._id)];
                        case 7:
                            _c.sent();
                            return [4, runUpdates(data.message.updated)];
                        case 8:
                            _c.sent();
                            return [3, 11];
                        case 9:
                            if (!(data.type === 'add')) return [3, 11];
                            if (!(data.source !== getSocketId())) return [3, 11];
                            return [4, handlerManager.template.get(data.entry._id)];
                        case 10:
                            _c.sent();
                            _c.label = 11;
                        case 11:
                            getSubscriptions()[interfaces_1.SocketEventName.TEMPLATE].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.WIDGET,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            return [4, cacheControl.widget.remove(data.entry._id)];
                        case 1:
                            _a.sent();
                            if (!(data.type !== 'remove')) return [3, 3];
                            return [4, handlerManager.widget.get(data.entry._id)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            if (!data.message.updated) return [3, 5];
                            return [4, runUpdates(data.message.updated)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            getSubscriptions()[interfaces_1.SocketEventName.WIDGET].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.MEDIA,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data, updates;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (!(data.source !== getSocketId())) return [3, 3];
                            return [4, cacheControl.media.remove(data.entry._id)];
                        case 1:
                            _a.sent();
                            if (!(data.type !== 'remove')) return [3, 3];
                            return [4, handlerManager.media.get(data.entry._id)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            if (!(data.type === 'update')) return [3, 7];
                            if (!(data.source !== getSocketId())) return [3, 5];
                            return [4, cacheControl.media.remove(data.entry._id)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [4, runUpdates(data.message.updated)];
                        case 6:
                            _a.sent();
                            return [3, 9];
                        case 7:
                            if (!(data.type === 'remove')) return [3, 9];
                            updates = data.message.updated.find(function (e) { return e.name === 'media'; });
                            if (!(updates && updates.ids.length > 0)) return [3, 9];
                            return [4, cacheControl.media.removeMany(updates.ids)];
                        case 8:
                            _a.sent();
                            _a.label = 9;
                        case 9:
                            getSubscriptions()[interfaces_1.SocketEventName.MEDIA].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.USER,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            return [4, cacheControl.user.remove(data.entry._id)];
                        case 1:
                            _a.sent();
                            if (!(data.type !== 'remove')) return [3, 3];
                            return [4, handlerManager.user.get(data.entry._id)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            getSubscriptions()[interfaces_1.SocketEventName.USER].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.API_KEY,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data, at;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            at = getAccessToken();
                            if (!(at && at.payload.roles[0].name === 'ADMIN')) return [3, 3];
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            cacheControl.apiKey.remove(data.entry._id);
                            if (!(data.type !== 'remove')) return [3, 2];
                            return [4, handlerManager.user.get(data.entry._id)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            getSubscriptions()[interfaces_1.SocketEventName.USER].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            _a.label = 3;
                        case 3: return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.ENTRY,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data, cachedEntry;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            cachedEntry = cacheControl.entry.get(data.entry._id);
                            if (!cachedEntry) return [3, 5];
                            cacheControl.entry.remove(data.entry._id);
                            if (!(data.type !== 'remove')) return [3, 4];
                            if (!(cachedEntry.lite === true)) return [3, 2];
                            return [4, handlerManager.entry.getManyLite([data.entry._id])];
                        case 1:
                            _a.sent();
                            return [3, 4];
                        case 2: return [4, handlerManager.entry.get({
                                id: data.entry._id,
                                templateId: data.entry.additional.templateId,
                            })];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4: return [3, 7];
                        case 5: return [4, handlerManager.entry.getLite({
                                templateId: data.entry.additional.templateId,
                                id: data.entry._id,
                            })];
                        case 6:
                            _a.sent();
                            _a.label = 7;
                        case 7:
                            getSubscriptions()[interfaces_1.SocketEventName.ENTRY].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.PLUGIN,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data, subs, key;
                return __generator(this, function (_a) {
                    data = rawData;
                    subs = getSubscriptions();
                    for (key in subs) {
                        if (key.startsWith('plugin_') &&
                            key.split('_').slice(1).join('_') === data.name) {
                            subs[key].forEach(function (sub) {
                                sub.handler(data.payload).catch(function (error) {
                                    console.error(error);
                                });
                            });
                        }
                    }
                    return [2];
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.STATUS,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = rawData;
                            if (data.source === getSocketId()) {
                                return [2];
                            }
                            cacheControl.status.remove(data.entry._id);
                            if (!(data.type !== 'remove')) return [3, 2];
                            return [4, handlerManager.status.get(data.entry._id)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            getSubscriptions()[interfaces_1.SocketEventName.STATUS].forEach(function (sub) {
                                sub.handler({ data: data }).catch(function (error) {
                                    console.error(error);
                                });
                            });
                            return [2];
                    }
                });
            }); },
        },
        {
            name: interfaces_1.SocketEventName.ENTRY_CHANGE,
            handler: function (rawData) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    data = rawData;
                    if (data.source !== getSocketId()) {
                        getSubscriptions()[interfaces_1.SocketEventName.ENTRY_CHANGE].forEach(function (sub) {
                            sub.handler(data).catch(function (error) {
                                console.error(error);
                            });
                        });
                    }
                    return [2];
                });
            }); },
        },
    ];
}
exports.SocketEventHandlers = SocketEventHandlers;
//# sourceMappingURL=event-handlers.js.map